import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/employee_certificates',
    name: 'EmployeeCertificate',
    component: {
      name: 'AdminEmployeeCertificate',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'certificate',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminEmployeeCertificateIndex',
        component: () => import('../views/admin/employees/CertificateAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminEmployeeCertificateNew',
        component: () => import('../views/admin/employees/CertificateAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminEmployeeCertificateIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminEmployeeCertificateShow',
        component: () => import('../views/admin/employees/CertificateAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminEmployeeCertificateIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminEmployeeCertificateDetails',
            component: () => import('../views/admin/employees/CertificateAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminEmployeeCertificateIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminEmployeeCertificateEdit',
            component: () => import('../views/admin/employees/CertificateAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminEmployeeCertificateDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminEmployeeCertificateAttachments',
            component: () => import('../views/admin/CertificateAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminEmployeeCertificateIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminEmployeeCertificateAttachmentsEdit',
            component: () => import('../views/admin/CertificateAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminCertificateAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'phases',
            name: 'AdminEmployeeCertificatePhases',
            component: () => import('../views/admin/CertificatePhases.vue'),
            meta: {
              backRoute: { name: 'AdminEmployeeCertificatesIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminEmployeeCertificateLogs',
            component: () => import('../views/admin/CertificateLogs.vue'),
            meta: {
              backRoute: { name: 'AdminEmployeeCertificateIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/machine_certificates',
    name: 'MachineCertificate',
    component: {
      name: 'AdminMachineCertificate',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'certificate',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminMachineCertificateIndex',
        component: () => import('../views/admin/machines/CertificateAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminMachineCertificateNew',
        component: () => import('../views/admin/machines/CertificateAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminMachineCertificateIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminMachineCertificateShow',
        component: () => import('../views/admin/machines/CertificateAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminMachineCertificateIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminMachineCertificateDetails',
            component: () => import('../views/admin/machines/CertificateAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminMachineCertificateIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminMachineCertificateEdit',
            component: () => import('../views/admin/machines/CertificateAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminMachineCertificateDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminMachineCertificateAttachments',
            component: () => import('../views/admin/CertificateAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminMachineCertificateIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'phases',
            name: 'AdminMachineCertificatePhases',
            component: () => import('../views/admin/CertificatePhases.vue'),
            meta: {
              backRoute: { name: 'AdminMachineCertificatesIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminMachineCertificateLogs',
            component: () => import('../views/admin/CertificateLogs.vue'),
            meta: {
              backRoute: { name: 'AdminMachineCertificateIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/certificates',
    name: 'UserCertificate',
    component: {
      name: 'UserCertificate',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'certificate',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserCertificateIndex',
        component: () => import('../views/user/CertificateUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserCertificateShow',
        component: () => import('../views/user/CertificateUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserCertificateIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserCertificateDetails',
            component: () => import('../views/user/CertificateUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserCertificateIndex' },
            },
          },
        ]
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));